import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss']
})
export class StatisticsComponent {
  totalMessages = 1247;
  uptime = 98.5;

  usageData = [
    { name: 'Facebook Pages', value: 768 },
    { name: 'WhatsApp Business', value: 456 },
    { name: 'Google Calendar', value: 79 },
    { name: 'Zoom Meetings', value: 66 }
  ];

  maxValue = Math.max(...this.usageData.map(u => u.value));

  constructor(public dialogRef: MatDialogRef<StatisticsComponent>) {}

  close() {
    this.dialogRef.close();
  }
}
